import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import { getDistributorDramaSources } from 'services/adToolsApi';

let sourceRequest;

/** 合作方可用剧目渠道由服务端配置控制，并发挂载只发一次请求。 */
function loadSources() {
  if (!sourceRequest) {
    sourceRequest = getDistributorDramaSources()
      .then((response) => {
        const data = response?.data || response || [];
        sourceRequest = null;
        return Array.isArray(data) ? data : [];
      })
      .catch((error) => {
        sourceRequest = null;
        throw error;
      });
  }
  return sourceRequest;
}

export default function DramaChannelSelect({ value, onChange, width = 112, label = '渠道', allowedSources }) {
  const [options, setOptions] = useState([]);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    let active = true;
    loadSources()
      .then((items) => {
        if (!active) return;
        const available = allowedSources ? items.filter((item) => allowedSources.includes(item.value)) : items;
        setOptions(available);
      })
      .catch(() => {
        if (active) setOptions([]);
      });
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (options.length && !options.some((item) => item.value === value)) {
      onChangeRef.current(options[0].value);
    }
  }, [options, value]);

  return (
    <TextField
      select
      size="small"
      aria-label={label}
      value={options.some((item) => item.value === value) ? value : ''}
      onChange={(event) => onChange(event.target.value)}
      sx={{ width, minWidth: width, '& .MuiOutlinedInput-root': { borderTopRightRadius: 0, borderBottomRightRadius: 0 } }}
    >
      {options.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

DramaChannelSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.number,
  label: PropTypes.string,
  allowedSources: PropTypes.arrayOf(PropTypes.string)
};
